const en = {

  // Login messages
  '401': { type: 'danger', text: 'Your session has expired, please login again' },
  '400': { type: 'danger', text: 'There seems to be a momentary issue. Please refresh or try again after sometime.' },
  '200': { type: 'success', text: 'success' },

  // event page
  '1001': { type: 'info', text: 'All Events' },
  '1002': { type: 'info', text: 'Filter by Committee(s)' },
  '1003': { type: 'info', text: 'Choose Committee(s)' },
  '1004': { type: 'info', text: 'Search by:' },
  '1005': { type: 'info', text: 'There presently are no Meetings, Symposia & Workshops available for the selected Committee(s).' },
  '1006': { type: 'info', text: 'There presently are no Meetings available for the selected Committee(s).' },
  '1007': { type: 'info', text: 'There presently are no Symposia & Workshops available for the selected Committee(s).' },

  // symposia workshop page
  '2001': { type: 'info', text: 'Overview' },
  '2002': { type: 'info', text: `ASTM symposia provide an opportunity for members and others to present their research findings and exchange information. Approximately 20 symposia are held annually on a wide variety of technical subjects. Often the discussion identifies critical areas facing today's emerging technologies and forms the technical basis for the development of new and revised ASTM International standards.` },
  '2003': { type: 'info', text: 'Symposia are sponsored by ASTM technical committees and are often held in cooperation with government agencies and national or international professional organizations. Attendees are eligible for Continuing Education Units (CEUs) at the end of each symposium. In addition, as a follow-up to the symposia, the papers presented are peer reviewed and published in one of the ASTM online journals.' },
  '2004': { type: 'info', text: 'Symposia Proposal Form' },
  '2005': { type: 'info', text: 'See Future ASTM Symposia and Workshops' },
  '2006': { type: 'info', text: 'Search Past ASTM Symposia' },
  '2007': { type: 'info', text: 'Receive Emails When New Papers Are Available' },

  // error
  '5000': { type: 'danger', text: 'No record found.' },
  '5001': { type: 'danger', text: 'Please select committee(s).' },
  '5002': { type: 'danger', text: 'Error occured while getting committee list.' },
  '5003': { type: 'danger', text: 'Error occured while getting event list.' },
  '5004': { type: 'danger', text: 'Error occured while getting sub committee list.' },

  //symposia proposal form
  '1010': { type: 'info', text: 'Please select the type of event' },
  '1011': { type: 'danger', text: 'Error occured while download template file' },
  '1012': { type: 'danger', text: 'Please enter a first name' },
  '1013': { type: 'danger', text: 'Please enter a last name' },
  '1014': { type: 'danger', text: 'Please enter an email address' },
  '1015': { type: 'danger', text: 'Please enter a phone number' },
  '1016': { type: 'danger', text: 'Please select a committee' },
  '1017': { type: 'danger', text: 'Please select a subcommittee' },
  '1018': { type: 'danger', text: 'Please select if you will be the Chair of the event' },
  '1019': { type: 'danger', text: 'Please select if this event will have any Co-Chairs' },
  '1020': { type: 'danger', text: 'Please enter an event title' },
  '1021': { type: 'danger', text: 'Please enter an objective for this event' },
  '1022': { type: 'danger', text: 'Please enter the list of topics to be covered in this event' },
  '1023': { type: 'danger', text: 'Please enter the details of the target audience for this event' },
  '1024': { type: 'danger', text: 'Please enter the expected attendance' },
  '1025': { type: 'danger', text: 'Please enter the number of presentations' },
  '1026': { type: 'danger', text: 'Please enter an objective for this event' },
  '1027': { type: 'danger', text: 'Please select the Type of ASTM publication' },
  '1028': { type: 'danger', text: 'Please select an ASTM Journal' },
  '1029': { type: 'danger', text: 'Please enter the number of papers' },
  '1030': { type: 'danger', text: 'Please select if call for papers needed' },
  '1031': { type: 'danger', text: 'Pease select if call for presentations needed' },
  '1032': { type: 'danger', text: 'Please select if this event will be held in conjunction with an already planned ASTM Committee Week' },
  '1033': { type: 'danger', text: 'Please select an ASTM committee week' },
  '1034': { type: 'danger', text: 'Please enter the poposed city for the event' },
  '1035': { type: 'danger', text: 'Please select the poposed country for the event' },
  '1036': { type: 'danger', text: 'Please select the poposed State/Province for the event' },
  '1037': { type: 'danger', text: 'Please select the Start Date' },
  '1038': { type: 'danger', text: 'Please select the End Date' },
  '1039': { type: 'danger', text: 'Please select the Start Time' },
  '1040': { type: 'danger', text: 'Please select the End Time' },
  '1041': { type: 'danger', text: 'Please select if you plan on having concurrent sessions' },
  '1042': { type: 'danger', text: 'Please select the number of sessions to take place at the same time' },
  '1043': { type: 'danger', text: 'Please enter number only' },
  '1044': { type: 'danger', text: 'Please select how many Co-Chairs' },
  '1045': { type: 'success', text: 'Proposal for Symposium added successfully.' },
  '1046': { type: 'danger', text: 'Please validate recaptcha.' },

  // Create My Agenda
  '1047': { type: 'danger', text: 'Please Select Subcommittee or Section' },
  '1048': { type: 'danger', text: 'Please Select The Date' },
  '1049': { type: 'danger', text: 'Please Enter The Location' },
  '1050': { type: 'danger', text: 'Please select the Meeting Start Time.' },
  '1051': { type: 'success', text: 'Please select the Meeting Duration.' },
  '1052': { type: 'danger', text: 'Error occured while downloading file' },
  '1053': { type: 'danger', text: 'Only alphanumeric with comma is allowed.' },
  '1054': { type: 'danger', text: 'Please enter the Meeting Title.' },

  // S3 File
  '1055': { type: 'warning', text: 'Document not found' },

  // Entitlement Error
  '1056': { type: 'danger', text: 'Error occured while getting Entitlement list.' },

  // MyMeeting Materials & MySchedule Error
  '1057': { type: 'danger', text: 'Error occured while getting Event list.' },
  '1058': { type: 'danger', text: 'Error occured while getting Committee list.' },
  '1059': { type: 'danger', text: 'Please select an option for all the items to proceed.' },
  '1060': { type: 'danger', text: 'Error occured while saving Meeting Materials.' },
  '1061': { type: 'danger', text: 'Error occured while getting Meeting list.' },
  '1062': { type: 'danger', text: 'Please enter the Meeting Location/Room.' },
  '1063': { type: 'danger', text: 'Please enter the Meeting Date.' },
  '1064': { type: 'danger', text: 'MAE data does not exist.' },

  //symposia proposal form
  '1200': { type: 'danger', text: 'Please enter valid email.' }

}

export default en;
